module.exports = __webpack_public_path__ + "assets/farming-left.d2d9ee7c.svg";